<template>
	<div>
		<loading v-if="loading" :full-page="true"></loading>
		<div v-if="!loading && !error" class="unauth-form">
			<div class="unauth-form-container">
				<logged-in-invitation-response-page v-if="!loading && loggedIn" :accept="accept" @reject="reject" :account="account" :invitation="invitation"></logged-in-invitation-response-page>
				<logged-out-invitation-response-page v-if="!loading && !loggedIn" :accept="accept" @reject="reject" :account="account" :invitation="invitation"></logged-out-invitation-response-page>
			</div>
		</div>
		<div v-if="!loading && error" class="unauth-form">
			<div class="unauth-form-container">
				<div class="title-container">
					<div class="title"><span class="fa fa-exclamation-triangle"></span>{{ errorTitle }}</div>
					<div class="buttons">
						<router-link to="/login" class="button"><div class="hover-title">Exit</div><span class="fa fa-key"></span></router-link>
					</div>
				</div>
				<div class="input-container">
					<div class="input-static-text">{{ error }}</div>
				</div>
			</div>
		</div>
		<div v-if="!loading && !error" class="unauth-decor">
			<div class="logo">
				<span class="fak fa-gravity-fox"></span>
			</div>
		</div>
	</div>
</template>

<script>

import { mapGetters } from 'vuex';
import LoggedInInvitationResponsePage from './LoggedInInvitationResponsePage';
import LoggedOutInvitationResponsePage from './LoggedOutInvitationResponsePage';

export default {

	name: 'InvitationResponsePage',

	data() {
		return {
			loading: true,
			account: {},
			invitation: {},
			loggedIn: false,
			error: null,
			errorTitle: 'Invitation Issue',
		};
	},

	computed: mapGetters([ 'isLoggedIn' ]),

	created() {
		this.loadInvitation();

		// Using this so it doesn't swap over to the logged-in component in the middl of submitting the auth form on logged out state
		this.loggedIn = this.isLoggedIn;
	},

	methods: {

		async loadInvitation() {
			this.loading = true;

			// Load invitation from server
			try {
				const { data } = await this.$api.post(`/account/connections/${ this.$route.params.accountId }/${ this.$route.params.userId }/respond`, { signature: this.$route.params.signature });

				if (data.data && data.data.account) {
					this.account = data.data.account;
					this.invitation = data.data.invitation;
				}
			} catch (e) {
				this.error = this.$api.getErrorMessage(e);
				this.$store.dispatch('addToast', { message: this.error, type: 'bad' });
			}

			this.loading = false;
		},

		async accept() {
			await this.sendResponse('accept');
		},

		async reject() {
			await this.sendResponse('reject');
		},

		async sendResponse(response) {
			await this.$api.post(`/account/connections/${ this.$route.params.accountId }/${ this.$route.params.userId }/${ response }`, { signature: this.$route.params.signature });

			this.$store.commit('clearPendingInvitation');

			if (response === 'accept') {
				this.$store.dispatch('getAccounts');
				this.$store.dispatch('addToast', 'You have accepted this invitation. Thank you for responding!');

				this.$router.replace({ name: 'accounts-switch', params: { id: this.$route.params.accountId } });
			} else {
				this.errorTitle = 'Invitation Rejected';
				this.error = `You have rejected your invitation to manage the ${ this.account.name } account. Thank you for responding to this invitation. No further action is required.`;
			}
		},

	},

	components: {
		LoggedInInvitationResponsePage,
		LoggedOutInvitationResponsePage,
	},

};

</script>
